import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { groupBy } from "lodash";
import {
  getRemoveCateringProductToCartList,
  updateToCartCateringAndMealKitItem,
  handleUpdateCateringAndMealCartCustomOption,
  addToCartCateringAndMealKitItem,
  getCartList
} from "redux/actions";
import CateringDropdown from "./CateringDropdown";
import CateringCheckBoxGroup from "./CateringCheckBoxGroup";
import CateringRadioGroup from "./CateringRadioGroup";
import { getLocalStorageValue } from "config/helper";
import { useGotoLogin } from 'hooks/useGotoLogin';
import { useApiDefaults } from 'hooks/useApiDefaults';

const CateringCartProduct = ({ product, productIndex }) => {
  const {
    image,
    name,
    qty = 1,
    final_price,
    product_id,
    final_total,
    custom_options_select,
    custom_options_arr,
    item_note,
    meal_cart_id,
    meal_item_id,
    sku
  } = product;
  const dispatch = useDispatch();
  const gotoLogin = useGotoLogin();
  const [productQuantity, setProductQuantity] = useState(+qty);
  const [isShowProductButton, setShowProductButton] = useState(false);
  const [updateProductNote, setUpdateProductNote] = useState(item_note ?? "");
  const { currentStoreID } = useSelector(({ store }) => store);
  const { selectedCateringAndMealCartOption } = useSelector(
    ({ cateringAndMeal }) => cateringAndMeal
  );

  useEffect(() => {
    setProductQuantity(+qty);
  }, [qty]);

  const {
    selectedCateringAndMealKitProductUpdateId,
    cateringAndMealKitProductUpdateLoading
  } = useSelector(({ cartWishlist }) => cartWishlist);

  const currentProduct = selectedCateringAndMealCartOption[productIndex] || {};

  const requiredOptions = custom_options_select
    ? custom_options_select.filter((option) => option.is_required === "1")
    : [];
  const requiredOptionsIds = requiredOptions.map((option) => option.id);
  const isDisabledAddToCart = !requiredOptionsIds.every((requiredOptionsId) => {
    return currentProduct[requiredOptionsId]
      ? !!currentProduct[requiredOptionsId].length
      : false;
  });

  const selectedOptionList = Object.values(currentProduct).flat();
  const optionItemList = selectedOptionList.filter(
    (option) => option.is_add_option_price === "1"
  );
  const displayOptionItemList = selectedOptionList.filter(
    (option) => option.is_add_option_price === "0"
  );

  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);

  const clientId = getLocalStorageValue("RSAclient-id");
  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");
  const userToken = getLocalStorageValue("user-token");
  const memberNumber = getLocalStorageValue("member-number");

  useEffect(() => {
    const selectedOptionsByGroup = groupBy(custom_options_arr, "option_id");
    dispatch(
      handleUpdateCateringAndMealCartCustomOption(
        selectedOptionsByGroup,
        productIndex
      )
    );
  }, [custom_options_arr]); // eslint-disable-line

  const [updatebutton, setUpdateButton] = useState();
  const apiDefaults = useApiDefaults()
  const handleUpdateProductToCart = (index) => {
    setUpdateButton(parseInt(index));
    const optionPrice = optionItemList.reduce((acc, cur) => {
      return (acc += +cur.price);
    }, 0);
    const displayOptionPrice = displayOptionItemList.reduce((acc, cur) => {
      return (acc += +cur.price);
    }, 0);

    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      product_id,
      qty: productQuantity,
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      item_note: updateProductNote,
      custom_options_arr: JSON.stringify(selectedOptionList) || "",
      option_price: optionPrice || "0",
      display_option_item_price: displayOptionPrice || "",
      meal_item_id
    };

    dispatch(updateToCartCateringAndMealKitItem(body)).then(() => {
      dispatch(getCartList(apiDefaults));
      setUpdateButton("");
      setShowProductButton(false);
    });
  };

  const handleAddToCart = () => {
    if (!isUserLoggedIn) {
      gotoLogin();
    }

    const optionPrice = optionItemList.reduce((acc, cur) => {
      return (acc += +cur.price);
    }, 0);
    const displayOptionPrice = displayOptionItemList.reduce((acc, cur) => {
      return (acc += +cur.price);
    }, 0);

    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      product_id,
      qty: productQuantity,
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      product_note: "",
      custom_options_arr: JSON.stringify(selectedOptionList) || "",
      option_price: optionPrice || "0",
      display_option_item_price: displayOptionPrice || ""
    };

    dispatch(addToCartCateringAndMealKitItem(body)).then(() => {
      dispatch(getCartList(apiDefaults));
    });

  };

  const handleRemoveProductToCart = () => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      meal_item_id,
      meal_cart_id,
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : ""
    };
    dispatch(getRemoveCateringProductToCartList(body)).then(() => {
      dispatch(getCartList(apiDefaults));
    });
  };

  const handleIncrementCount = () => {
    setProductQuantity(productQuantity + 1);
    setShowProductButton(true);
  };
  const handleDecrementCount = () => {
    if (productQuantity > 1) {
      setProductQuantity(productQuantity - 1);
    }
    setShowProductButton(true);
    return productQuantity;
  };

  const handleChangeProductNote = (value) => {
    setUpdateProductNote(value);
    setShowProductButton(true);
  };

  return (
    <div className="cart-items-list-view-section" key={product_id}>
      <div className="sub-grid">
        <div className="sub-grid-items">
          <div className="product-view-grid">
            <div className="product-view-grid-items">
              <div className="product-image-show">
                <img src={image} alt="ProductImage" />
              </div>
            </div>
            <div className="product-view-grid-items">
              <div className="title-icon-mobile-show">
                <div className="mobile-view-title-icon-align">
                  <div className="icon-remove" onClick={handleRemoveProductToCart}>
                  <i
                    className="fa-solid fa-trash-can"></i>
                  </div>
                  <span></span>
                </div>
              </div>
              <div className="product-name">
                <Link
                  to={product.is_mealkit == "0" ? (`/product-description/${product.department_slug}/${product.slug}`) : (`/catering-product-description/${product.department_slug}/${product.slug}`)}>
                  <h6>{name}</h6>
                </Link>
                {/* add on bottom */}
                {isShowProductButton && (
                  <div
                    className={`update-button desktop-update-btn${isDisabledAddToCart ? "disabled" : ""
                      }`}>
                    <button
                      disabled={isDisabledAddToCart}
                      onClick={() => handleUpdateProductToCart(productIndex)}>
                      {selectedCateringAndMealKitProductUpdateId ===
                        product_id &&
                        productIndex === updatebutton &&
                        cateringAndMealKitProductUpdateLoading
                        ? "Updating.."
                        : "Update"}
                    </button>
                  </div>
                )}
              </div>

              <p className="product-sku">
                UPC: <span> {sku}</span>
              </p>

              <h5>By Best Choice</h5>
              <font>${final_total}</font>
              {/* <div className="whishlist-icon">
              <div className="icon">
            <svg className="add-whishlist" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-opacity="0" d="M12 8c0 0 0 0 0.76 -1c0.88 -1.16 2.18 -2 3.74 -2c2.49 0 4.5 2.01 4.5 4.5c0 0.93 -0.28 1.79 -0.76 2.5c-0.81 1.21 -8.24 9 -8.24 9c0 0 -7.43 -7.79 -8.24 -9c-0.48 -0.71 -0.76 -1.57 -0.76 -2.5c0 -2.49 2.01 -4.5 4.5 -4.5c1.56 0 2.87 0.84 3.74 2c0.76 1 0.76 1 0.76 1Z"><animate fill="freeze" attributeName="fill-opacity" begin="0.7s" dur="0.5s" values="0;1"/></path><path fill="none" stroke="currentColor" stroke-dasharray="32" stroke-dashoffset="32" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c0 0 0 0 -0.76 -1c-0.88 -1.16 -2.18 -2 -3.74 -2c-2.49 0 -4.5 2.01 -4.5 4.5c0 0.93 0.28 1.79 0.76 2.5c0.81 1.21 8.24 9 8.24 9M12 8c0 0 0 0 0.76 -1c0.88 -1.16 2.18 -2 3.74 -2c2.49 0 4.5 2.01 4.5 4.5c0 0.93 -0.28 1.79 -0.76 2.5c-0.81 1.21 -8.24 9 -8.24 9"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.7s" values="32;0"/></path></svg>
              </div>
            </div> */}
              {/* 
      <div className="rating-alignment">
        <div className="star">
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star"></i>
        </div>
        <div className="count">
          <span>(4.0)</span>
        </div>
      </div> */}
              <div className="mobile-view-show">
                <div className="mobiel-quantity-button">
                  <button className="">
                    <span>{productQuantity}</span>
                    <div className="arrow-alignment">
                      <div onClick={() => handleIncrementCount()}>
                        <i className="fa-solid fa-angle-up" onClick={() => handleIncrementCount()}></i>
                      </div>
                      <div onClick={() => handleDecrementCount()}>
                        <i className="fa-solid fa-angle-down" onClick={() => handleDecrementCount()}></i>
                      </div>
                    </div>
                  </button>
                  <div className="duplicate-item">
                    <span onClick={handleAddToCart}>Duplicate item</span>
                  </div>
                </div>
                {isShowProductButton && (
                  <div
                    className={`update-button ${isDisabledAddToCart ? "disabled" : ""
                      }`}>
                    <button
                      disabled={isDisabledAddToCart}
                      onClick={() => handleUpdateProductToCart(productIndex)}>
                      {selectedCateringAndMealKitProductUpdateId ===
                        product_id &&
                        productIndex === updatebutton &&
                        cateringAndMealKitProductUpdateLoading
                        ? "Updating.."
                        : "Update"}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="sub-grid-items">
          <div className="all-action-alignment">
            <div className="price-count">
              <span>${final_price}</span>
            </div>
            <div className="quantity-button ">
              <button className="">
                <span>{productQuantity}</span>
                <div className="arrow-alignment">
                  <div onClick={() => handleIncrementCount()}>
                    <i className="fa-solid fa-angle-up" onClick={() => handleIncrementCount()}></i>
                  </div>
                  <div onClick={() => handleDecrementCount()}>
                    <i className="fa-solid fa-angle-down" onClick={() => handleDecrementCount()}></i>
                  </div>
                </div>
              </button>

              <div className="duplicate-item">
                <span onClick={handleAddToCart}>Duplicate item</span>
              </div>
            </div>
            <div className="price-count">
              <span>${final_total}</span>
            </div>
            {/* <div className="whishlist-icon">
              <div className="icon">
            <svg className="add-whishlist" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-opacity="0" d="M12 8c0 0 0 0 0.76 -1c0.88 -1.16 2.18 -2 3.74 -2c2.49 0 4.5 2.01 4.5 4.5c0 0.93 -0.28 1.79 -0.76 2.5c-0.81 1.21 -8.24 9 -8.24 9c0 0 -7.43 -7.79 -8.24 -9c-0.48 -0.71 -0.76 -1.57 -0.76 -2.5c0 -2.49 2.01 -4.5 4.5 -4.5c1.56 0 2.87 0.84 3.74 2c0.76 1 0.76 1 0.76 1Z"><animate fill="freeze" attributeName="fill-opacity" begin="0.7s" dur="0.5s" values="0;1"/></path><path fill="none" stroke="currentColor" stroke-dasharray="32" stroke-dashoffset="32" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c0 0 0 0 -0.76 -1c-0.88 -1.16 -2.18 -2 -3.74 -2c-2.49 0 -4.5 2.01 -4.5 4.5c0 0.93 0.28 1.79 0.76 2.5c0.81 1.21 8.24 9 8.24 9M12 8c0 0 0 0 0.76 -1c0.88 -1.16 2.18 -2 3.74 -2c2.49 0 4.5 2.01 4.5 4.5c0 0.93 -0.28 1.79 -0.76 2.5c-0.81 1.21 -8.24 9 -8.24 9"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.7s" values="32;0"/></path></svg>
              </div>
            </div> */}
            <div className="remove-icon" onClick={handleRemoveProductToCart}>
              <i className="fa-solid fa-trash-can"></i>
            </div>
          </div>
        </div>
      </div>
      <div className="catering-allow-substitition-grid">
        {custom_options_select &&
          custom_options_select.map((option) => {
            if (option.values && !!option.values.length) {
              return (
                <div key={option.option_id} className="">
                  {option.type === "dropdown" ? (
                    <div className="substitution">
                      <p>
                        <strong>{option.title}</strong>
                        {option.is_required === "1" && <span>*</span>}
                      </p>
                      <div className="select-substitition-dropdown">
                        <CateringDropdown
                          optionList={
                            option.values
                              ? option.values.map((list) => {
                                return {
                                  title: list.value,
                                  value: list.id,
                                  option: list
                                };
                              })
                              : []
                          }
                          lable=""
                          placeholder="Select Option"
                          defaultValue=""
                          groupData={option}
                          custom_options_arr={custom_options_arr}
                          productIndex={productIndex}
                          setShowProductButton={() =>
                            setShowProductButton(true)
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {option.type === "radio" ? (
                    <CateringRadioGroup
                      groupData={option}
                      custom_options_arr={custom_options_arr}
                      productIndex={productIndex}
                      setShowProductButton={() => setShowProductButton(true)}
                    />
                  ) : (
                    ""
                  )}
                  {option.type === "checkbox" ? (
                    <CateringCheckBoxGroup
                      groupData={option}
                      custom_options_arr={custom_options_arr}
                      productIndex={productIndex}
                      setShowProductButton={() => setShowProductButton(true)}
                    />
                  ) : (
                    ""
                  )}
                </div>
              );
            } else {
              return <div className="allow-substitition-grid-items"></div>;
            }
          })}
      </div>
      <div className="catering-textarea-style">
        <textarea
          onChange={(e) => {
            handleChangeProductNote(e.target.value);
          }}
          placeholder="Enter item notes or substitution notes..."
          value={updateProductNote}></textarea>
      </div>
    </div>
  );
};

export default CateringCartProduct;
